import React from "react";
import { Redirect, withRouter } from "react-router-dom";
const RedirectAs404 = ({ location, }) => React.createElement(Redirect, { to: Object.assign({}, location, { state: { is404: true } }) });
export default withRouter(RedirectAs404);
